<template>
  <header>
    <h1>Monkey AST Visualizer</h1>
  </header>
</template>

<script>
export default {
  name: "Header"
};
</script>

<style lang="scss">
header {
  color: #ffdd00;

  h1 {
    font-size: 3rem;
    font-weight: 900;
    text-transform: uppercase;
    font-family: "Piedra", cursive;
    margin-bottom: 12px;
  }
}
</style>
